import * as React from 'react';
import { Button, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@repo/ui-web';
import { tooltipStates } from '../../catalog/component-states';
import { StateToggle } from '../../components/StateToggle';

type TooltipState = (typeof tooltipStates)[number];

export function TooltipShowcase() {
  const [state, setState] = React.useState<TooltipState>('default');
  const content =
    state === 'long'
      ? 'Share accurate billing details. This will appear on every invoice sent to your customers.'
      : 'Tooltip text.';

  return (
    <div className="space-y-4">
      <StateToggle options={tooltipStates} value={state} onChange={setState} label="Content" />
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button size="md" variant="outline">
              Hover me
            </Button>
          </TooltipTrigger>
          <TooltipContent>{content}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
